import React, {ReactNode} from 'react'
import {Field} from 'react-final-form'
import styles from './RadioField.scss'

const RadioField = <T, >(
  {children, idPrefix = '', isVan, isMap, ...props}: {
    name: string
    value: T
    children: ReactNode
    disabled?: boolean
    parse?: (value: string) => T
    idPrefix?: string
    initialValue?: any
    isVan?: boolean
    isMap?: boolean
  }
) => {
  const {name, value} = props
  const id = `${idPrefix}${name}-${value}`
  return <div className="custom-form custom-radio">
    <Field
      {...props}
      className={['custom-control-input', isVan && styles.inputVan].filter(Boolean).join(' ')}
      id={id}
      component="input"
      type="radio"
    />
    <label className={['custom-control-label', isVan && styles.labelVan, isMap && styles.mapIcon].filter(Boolean).join(' ')}
           htmlFor={id}>
      {children}
    </label>
  </div>

}
RadioField.displayName = 'RadioField'
export default RadioField
